import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ce57cb9c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tcg-page"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_ShareBox = _resolveComponent("ShareBox");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_sticky, {
    onChange: $options.handleStickyAction
  }, {
    default: _withCtx(() => [_createElementVNode("header", {
      class: _normalizeClass([{
        headerAndroid: $data.env.isModianAndroid()
      }]),
      style: _normalizeStyle({
        'padding-top': $data.statusBarH + 'px'
      })
    }, [($data.env.isModianIos() || $data.env.isModianIosNew() || $data.env.isModianAndroid()) && !$data.is_ip ? (_openBlock(), _createBlock(_component_van_image, {
      key: 0,
      class: _normalizeClass(["back-icon", {
        isFix: $data.isFix
      }]),
      "lazy-load": "",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/nav_back.png', 56),
      onClick: _withModifiers($options.handleGoBack, ["stop"])
    }, null, 8, ["class", "src", "onClick"])) : _createCommentVNode("", true)], 6)]),
    _: 1
  }, 8, ["onChange"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pageImages, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "tcg-page-item",
      key: item
    }, [$data.pageVideos[index] ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass([index === 1 ? 'tcg-page-item-video' : 'tcg-page-item-video1'])
    }, [index === 1 ? (_openBlock(), _createElementBlock("video", {
      key: 0,
      ref_for: true,
      ref: "firstVideo",
      src: $data.pageVideos[index] + '#t=0.1',
      muted: "",
      autoplay: "",
      loop: "",
      playsinline: "",
      "webkit-playsinline": "true",
      "x5-playsinline": "true",
      "x5-video-player-type": "h5-page",
      controls: "",
      controlslist: "nodownload noplaybackrate",
      disablePictureInPicture: "",
      preload: "auto",
      onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
      onLoadeddata: _cache[1] || (_cache[1] = (...args) => $options.showFirstVideoFirstFrame && $options.showFirstVideoFirstFrame(...args))
    }, null, 40, _hoisted_2)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createElementVNode("video", {
      ref_for: true,
      ref: "secondVideo",
      src: $data.pageVideos[index] + '#t=0.1',
      playsinline: "",
      "webkit-playsinline": "true",
      "x5-playsinline": "true",
      "x5-video-player-type": "h5-page",
      controls: "",
      controlslist: "nodownload noplaybackrate",
      disablePictureInPicture: "",
      preload: "auto",
      onContextmenu: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
      onLoadeddata: _cache[3] || (_cache[3] = (...args) => $options.showSecondVideoFirstFrame && $options.showSecondVideoFirstFrame(...args)),
      onPlay: _cache[4] || (_cache[4] = (...args) => $options.onSecondVideoPlay && $options.onSecondVideoPlay(...args)),
      onEnded: _cache[5] || (_cache[5] = $event => $data.secondVideoPlaying = false)
    }, null, 40, _hoisted_3), !$data.secondVideoPlaying ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "video-play-mask",
      onClick: _cache[8] || (_cache[8] = _withModifiers((...args) => $options.playSecondVideo && $options.playSecondVideo(...args), ["stop"]))
    }, [_createElementVNode("img", {
      class: "play-icon",
      src: "https://s.moimg.net/m/images/video-play.png",
      alt: "",
      draggable: "false",
      onContextmenu: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
      onDragstart: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
    }, null, 32)])) : _createCommentVNode("", true)], 64))], 2)) : _createCommentVNode("", true), _createElementVNode("img", {
      src: item,
      alt: "",
      draggable: "false",
      onContextmenu: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
      onDragstart: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
    }, null, 40, _hoisted_4), index === 2 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "tcg-page-btn",
      onClick: _cache[11] || (_cache[11] = (...args) => $options.getInviteCode && $options.getInviteCode(...args))
    })) : _createCommentVNode("", true)]);
  }), 128)), _createElementVNode("div", {
    class: "tcg-page-bottom",
    onClick: _cache[14] || (_cache[14] = (...args) => $options.getInviteCode && $options.getInviteCode(...args))
  }, [_createElementVNode("img", {
    class: "hand-guide",
    src: "https://p6.moimg.net/md/activity/tcg/app_activity_tcg_hand.png",
    alt: "",
    draggable: "false",
    onContextmenu: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
    onDragstart: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"]))
  }, null, 32)]), _createVNode(_component_ShareBox)]);
}